import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'

import { ToastProvider } from '@wartek-id/toast'

import { Layout as BaseLayout } from 'components/Layout/Layout'
import { USER_ID_STORAGE_KEY } from 'configs/auth'
import AndroidHandler, {
  createAndroidAuthDataCallback,
} from 'utils/androidHandler'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import '@wartek-id/design-tokens/build/guru-mobile/css/color.css'
import '@wartek-id/design-tokens/build/guru-mobile/css/font.css'
import '@wartek-id/design-tokens/build/guru-mobile/css/size.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import 'styles/global.css'
import useRouterHistory from 'utils/hooks/useRouterHistory'

createAndroidAuthDataCallback()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
  const mockServer = require('configs/mocks/server').default
  mockServer({ environment: process.env.NODE_ENV })
}

const App = ({ Component, pageProps, router }) => {
  useRouterHistory()
  const Layout = Component.Layout ?? BaseLayout

  return (
    <Layout {...Component.layoutOpts}>
      <Component {...pageProps} key={router.route} />
    </Layout>
  )
}

const AppProvider = ({ Component, pageProps, router }) => {
  const androidHandler = AndroidHandler()
  const [userId, setUserId] = useLocalStorage(USER_ID_STORAGE_KEY, null)
  // TODO: refactor this implementation
  const androidUserId = androidHandler?.enabled
    ? androidHandler?.getUserId()
    : null

  React.useEffect(() => {
    setUserId(androidUserId)
  }, [androidUserId, userId, setUserId])
  return (
    <div>
      <ToastProvider autoDismiss placement="top-center">
        {/** @ts-expect-error */}
        <QueryClientProvider client={queryClient}>
          <App Component={Component} pageProps={pageProps} router={router} />
        </QueryClientProvider>
      </ToastProvider>
    </div>
  )
}

export default AppProvider
